import * as firebase from 'firebase/app';
import 'firebase/auth';
import { UPDATE_PASSWORD_FAILURE, UPDATE_PASSWORD_SUCCEEDED } from './types';

// Update firebase user password
export const changePassword = (
  currentPassword,
  newPassword
) => async dispatch => {
  try {
    const currentUser = firebase.auth().currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(
      currentUser.email,
      currentPassword
    );
    return currentUser
      .reauthenticateWithCredential(credential)
      .then(() => currentUser.updatePassword(newPassword))
      .then(() => dispatch({ type: UPDATE_PASSWORD_SUCCEEDED }));
  } catch (err) {
    dispatch({ type: UPDATE_PASSWORD_FAILURE, payload: `error: ${err}` });
  }
};
